module.exports = __webpack_public_path__ + "static/media/Product_Cats.1ec80b1b.png";